import React, { useState, useRef } from 'react'
import { Breadcrumb } from 'antd'
import MNWaterfallApi from 'component/waterfall/masonryApi'
import ChooseTaskStyleCard from 'component/waterfall.card/chooseTaskStyle'
import TargetCategory from './targetCategory'
import User from './user'
import styles from './index.module.less'

export default ({ onBack, currentTask }) => {
  const [params, setParams] = useState({})
  const $masonry = useRef()
  return <div className={styles['mn-choose-task-inspiration']}>
    <div className="mn-choose-task-inspiration-header">
      <Breadcrumb className="mn-breadcrumb">
        <Breadcrumb.Item><span style={{ cursor: 'pointer' }} onClick={() => onBack()}>选款任务(Beta)</span></Breadcrumb.Item>
        <Breadcrumb.Item>{currentTask.missionName}</Breadcrumb.Item>
      </Breadcrumb>
    </div>
    <div className="mn-choose-task-inspiration-filter">
      <TargetCategory
        value={params.targetIdList?.[0]}
        onChange={(val) => setParams({ targetIdList: [val] })}
        currentTask={currentTask}
      />
      <User value={params.userIdList} onChange={userIdList => setParams(pre => ({ ...pre, userIdList }))} missionId={currentTask.id} />
    </div>
    <div className="mn-choose-task-inspiration-list">
      <MNWaterfallApi
        renderItem={ChooseTaskStyleCard}
        gutter={24}
        cardProps={{
          initSubColls: () => {
            $masonry.current?.init()
          },
        }}
        url="/zhikuan/ins/blog/mission/list-mission-blog"
        method="post"
        params={{
          missionId: currentTask.id,
          ...params,
        }}
        ref={$masonry}
        emptyText="暂无相关款式"
        emptyType="task"
      />
    </div>

  </div>
}
